<template>
	<v-row class="d-flex align-center header-container">
		<v-col cols="12">
			<v-row class="d-flex justify-space-between">
				<v-col cols="10">
					<v-row>
						<v-col class="d-flex" cols="12" :sm="5" :md="2">
							<v-img src="../../assets/logo.png" max-height="50" max-width="100" transition="scale-transition"></v-img>
						</v-col>
						<v-col cols="12" :sm="5" :md="2">
							<v-btn @click="$router.go(-1)" outlined class="text-transform-none">
								<v-icon>mdi-arrow-left </v-icon> {{ $t('headersale.exit') }}
							</v-btn>
						</v-col>
					</v-row></v-col
				>
				<v-col cols="1" class="d-flex justify-end" v-if="$vuetify.breakpoint.xsOnly">
					<v-app-bar-nav-icon @click="SHOW_SIDE_NAV"></v-app-bar-nav-icon>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols="12" class="pb-8">
			<v-row>
				<v-col class="d-flex justify-center align-center" v-if="titleLogoUrl !== '' && titleLogoUrl !== null" cols="12" md="2">
					<v-img
						class="title-img"
						@click="redirectEventWeb"
						:src="titleLogoUrl"
						:max-height="`${$vuetify.breakpoint.smAndDown ? '300' : 80}`"
						transition="scale-transition"
						alt="logo"
					></v-img>
				</v-col>
				<v-col cols="12" md="10">
					<h1>{{ $t('headerSale.text') }} {{ getEvent.evtrname }}</h1>
					<p class="font-weight-medium grey--text mb-0">{{ getEvent.evtrdescrip }}</p>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	props: {
		titleLogoUrl: {
			type: String,
			default: ''
		}
	},
	methods: {
		...mapActions(['SHOW_SIDE_NAV']),
		redirectEventWeb() {
			window.open(this.getEvent.evenweb, '_blank');
		}
	},
	computed: {
		...mapGetters(['getEvent'])
	}
};
</script>

<style lang="scss" scoped>
.v-btn {
	text-transform: none !important;
}
.v-btn--outlined {
	border: solid 1px #d2d7d9;
}
.header-container {
	margin-top: 15px;
}

.title-img {
	cursor: pointer;
	background-size: contain;
}
</style>
